export default __webpack_public_path__ + "static/media/melasmap.81685fbb.pdf";